import { Box, Chip, IconButton, Paper, Switch, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { BookingService, CustomerService } from '../Service';
import { PermissionGuard } from '../../../components/PermissionGuard';
import { Cancel, CheckCircle } from '@mui/icons-material';

const IsTestBooking = ({isTestBooking,fetchData}) => {
  const {bookingId} = useParams();
  const handleStatusChange = async() => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: isTestBooking?'Do you want to change testBooking status false?':'Do you want to make this booking a testBooking?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, change it!'
    });
    if (result.isConfirmed) {
      const loading = Swal.fire({
        title: 'Please wait ...',
        didOpen: () => {
          Swal.showLoading()
        },
      });
      
      const response = await BookingService.modifyIsTestBookingStatus(bookingId);
      if(response.success == '1'){
        loading.close();
        Swal.fire(
          'Changed!',
          `${response.message || 'TestBooking status has been changed'}.`,
          'success'
        );
        fetchData();        
      }else{
        loading.close();
        Swal.fire(
          'Failed!',
          'Failed to change testBooking status.',
          'error'
        );
      }
    }
  }
  return (
    <Box sx={{ p: 1, display: 'flex', alignItems: 'center',}}>
      <Chip
        label={'IsTestBooking'}
        color="primary"
        variant="outlined"
        size="small" 
        sx={{fontWeight:'500',
              fontSize:'x-small',color: '#ffffff',
              bgcolor:'#000000'}}
      />
      <PermissionGuard feature={'test-booking'} permission={'canEdit'}>
        <Switch
        size='small'
        checked={isTestBooking}
        onChange={()=>handleStatusChange()}
        sx={{
          '& .MuiSwitch-switchBase.Mui-checked': {
              color: 'success.main',
          },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: 'success.main'
          },
          '& .MuiSwitch-switchBase': {
              color: 'error.main',
          },
          '& .MuiSwitch-track': {
              backgroundColor: 'error.main'
          }
        }}
        inputProps={{ 'aria-label': 'controlled' }}
      />
      </PermissionGuard>
      
      <IconButton size='small' sx={{ p: 0 ,ml:'.5%'}}>
              {
                isTestBooking ?
                  <CheckCircle color='success' sx={{ fontSize: '1rem' }} />
                  : <Cancel color='error' sx={{ fontSize: '1rem' }} />
              }
            </IconButton>
    </Box>
  );
}

export default IsTestBooking;
